import React from 'react';
import { Button } from '@mui/material';
import { PHONE_VERIFICATION_REQUIRED_TITLE, requestPhoneVerification } from 'utils/phoneVerificationGate';

type Props = {
  /** Screen-scoped automation id, e.g. "talent-available-shifts-phone-verification-required". */
  testId: string;
};

/** T2-7517: shown instead of shift data while the server requires a verified phone. */
export default function PhoneVerificationRequired({ testId }: Props) {
  return (
    <div
      data-testid={testId}
      role="status"
      style={{
        background: 'rgba(11, 69, 152, 0.06)',
        border: '1px solid rgba(11, 69, 152, 0.2)',
        borderRadius: 12,
        padding: 16,
        margin: '12px 16px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 12,
      }}
    >
      <div style={{ color: '#0B4598', fontSize: 15, fontWeight: 600 }}>{PHONE_VERIFICATION_REQUIRED_TITLE}</div>
      <Button
        variant="contained"
        onClick={() => requestPhoneVerification()}
        data-testid={`${testId}-verify-button`}
        className="no-fastclick"
        sx={{ backgroundColor: '#0B4598', textTransform: 'none', fontWeight: 600 }}
      >
        Verify
      </Button>
    </div>
  );
}
